import { defineStore } from 'pinia';
import type { InboundDelivery } from '../domain/inboundDelivery';
import { useEntityStore } from 'shared/common/composables/entityStore';
import { computed } from 'vue';

export const useInboundDeliveryStore = defineStore('inbound-deliveries', () => {
  const { add, clear, getById, merge, remove, list, changed } = useEntityStore<InboundDelivery>({
    eventName: 'inbound-delivery-changed',
    getEntityId: (e) => e.id,
    updateEntity: (dest, src) => {
      dest.name = src.name;
      dest.customer = src.customer;
      dest.customerReference = src.customerReference;
      dest.note = src.note;
      dest.status = src.status;
      dest.plannedStartUtc = src.plannedStartUtc;
      dest.plannedFinishUtc = src.plannedFinishUtc;
      dest.actualStartUtc = src.actualStartUtc;
      dest.actualFinishUtc = src.actualFinishUtc;
      dest.createdAtUtc = src.createdAtUtc;
      dest.rows = src.rows;
    },
  });

  return {
    add,
    clear,
    getById,
    merge,
    remove,
    list: computed(() => list.value),
    changed,
  };
});
